var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.5V6m0 1.313V7.5m-4.5-3.21a4 4 0 1 0 1.5 6.355M21 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.318 14h5.364c.483 0 .724 0 .94.046.747.16 1.393.72 1.755 1.523.104.232.18.507.333 1.059.183.662.275.993.287 1.26.044.943-.465 1.794-1.221 2.042-.215.07-.505.07-1.084.07H8.308c-.58 0-.87 0-1.084-.07-.756-.248-1.265-1.1-1.221-2.042.012-.267.104-.598.287-1.26.153-.552.229-.827.333-1.059.362-.803 1.008-1.363 1.755-1.523.216-.046.457-.046.94-.046Z",
    stroke: "#464455",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAttention);
export default __webpack_public_path__ + "static/media/user-attention.f2278652fe0ee176e00e9b4285d5631b.svg";
export { ForwardRef as ReactComponent };